import Box from '@mui/material/Box';
import { FeaturedTrialType } from '../../components/shared/Carousel/Carousel.types';
import CarouselWrapper from '../shared/Carousel/CarouselWrapper/CarouselWrapper';

const FeaturedTrial = (props: FeaturedTrialType): JSX.Element => {
  if (!props.fields) {
    return <></>;
  }
  return (
    <Box id="featured-trial" sx={{ padding: '48px 8px', height: '810px' }}>
      <CarouselWrapper
        {...props}
        identifier="featured-trials-carousal"
        callerComponent="FeaturedTrials"
      />
    </Box>
  );
};

export default FeaturedTrial;
